export const APPLICATION_ID = 7
export const TRANSACTION_CHARGES = {
    BLOCKPAY: 0.1,
    EWALLET: 1.15,
    MASSPAY: 0
}

// ** Costo de la transacción por comercio de destino.
//
// Mismos valores que TRANSACTION_CHARGES, indexados por el id de merchant que viaja en
// `merchantDestination` del payload, para poder mostrar el costo en el paso de elegir
// destino: ahí todavía no hay importe, solo el tipo de cuenta.
//
// Masspay no estaba en el mapa original porque nunca se le calculaba cargo; se declara
// explícito en 0 para que "sin costo" sea un dato y no la ausencia de uno.
export const CHARGE_BY_MERCHANT = {
    9: TRANSACTION_CHARGES.BLOCKPAY,
    4: TRANSACTION_CHARGES.EWALLET,
    15: TRANSACTION_CHARGES.MASSPAY
}

// ** Importe mínimo de una transferencia.
//
// Vive aquí porque lo comparten el esquema de validación y el formulario: el esquema lo
// rechaza al enviar y el formulario apaga el botón de avance con el mismo umbral, y si
// cada uno tuviera el suyo el botón dejaría pasar importes que el esquema rechaza.
export const MIN_TRANSFER = 2

export const CodeHistoryType  = {
    FORGOT_PASSWORD: 1,
    CHANGE_EMAIL: 2
}

// ** Soporte -------------------------------------------------------------------------------
//
// Los tickets se abren en Lyra, en la opción SAC. Vive aquí porque lo usan Preguntas
// frecuentes y el acuerdo del cupo, donde se pide corregir los datos del IBO antes de firmar.
export const LYRA_LOGIN = "https://lyra.visionbiz.net/login/"
